import axios from 'axios';
import {
	dataRangeFrom,
	dataRangeTo,
	getConsentExpiryDate,
	getConsentStartDate,
	getDateRangeByPurposeAndFiTypes,
} from '../utils/getDate.utils';
import { getDataFilter } from '../utils/getDataFilter';
// import { removeIST } from '../utils/removeIST.utils';

const now = new Date();
const timestamp = now.toISOString().replace(/[:\-T.Z]/g, '');
const requestId = `${timestamp}-${Math.floor(Math.random() * 1000000)}`;
const channelId = JSON.parse(sessionStorage.getItem('login'))?.authUser
	?.channelId;

const optionalHeaders = {
	rid: requestId,
	ts: now.toISOString(),
	channelId: channelId,
};

export default class ReportApi {
	constructor() {
		this.api_token = null;
		this.client = null;
		this.api_url =
			window.location.hostname === 'localhost'
				? 'https://webreact.fiu.finfactor.in'
				: window.location.origin;
	}

	getToken() {
		const token = JSON.parse(sessionStorage.getItem('login'))?.token;
		return token;
	}

	//creates an axios instance
	init(baseURL = this.api_url) {
		this.api_token = this.getToken();

		const headers = {
			Authorization: `Bearer ${this.api_token}`,
			Accept: 'application/json',
			withCredentials: process.env.REACT_APP_LOGIN_API !== 'Login',
		};

		this.client = axios.create({
			baseURL: baseURL,
			timeout: 300000,
			headers: headers,
		});

		return this.client;
	}

	getApprovedConsentTemplates = () => {
		return this.init().get(`/finsense/API/V2/ConsentTemplates/Approved`);
	};
	getConsentsByCustomerId = (customerId) => {
		return this.init().get(
			`/finsense/API/V2/GetCustomerConsents?customerId=${customerId}`
		);
	};

	getConsentRequests = (customerId, requestDate) => {
		return this.init().get(
			`/finsense/API/V2/getConsentDetails?customerId=${customerId}&consentRequestDate=${requestDate}`
		);
	};

	getConsentStatus = (consentHandleId, customerId) => {
		return this.init().get(
			`/finsense/API/V2/ConsentStatus/${consentHandleId}/${customerId}`
		);
	};
	getConsentDetialsById = (consentHandleId) => {
		return this.init().get(
			`/finsense/API/V2/getConsentDetailsById/${consentHandleId}`
		);
	};

	getDataStatus = (consentId, sessionId, consentHandleId, custId) => {
		return this.init().get(
			`finsense/API/V2/dashboard/consents/${consentId}/sessions/${sessionId}/fi-status`
		);
	};

	getFIData = (consentHandle, sessionId, linkRefNo) => {
		return this.init().get(
			linkRefNo
				? `finsense/API/V2/FIDataFetch/${consentHandle}/${sessionId}?linkRefNumber=${linkRefNo}`
				: `finsense/API/V2/FIDataFetch/${consentHandle}/${sessionId}`
		);
	};

	getFIDataPDF = (consentHandle, sessionId, linkRefNo) => {
		return this.init().get(
			linkRefNo
				? `finsense/API/V2/FIDataFetch/${consentHandle}/${sessionId}?linkRefNumber=${linkRefNo}`
				: `finsense/API/V2/FIDataFetch/${consentHandle}/${sessionId}`,
			{
				headers: { Accept: 'application/pdf' },
				responseType: 'blob',
			}
		);
	};

	getFIDataReport = (consentHandle, sessionId, linkRefNo) => {
		return this.init().get(
			`finsense/API/V2/FIDataReportWeb/${consentHandle}/${sessionId}/${linkRefNo}`
		);
	};

	getFIDataReportPDF = (consentHandle, sessionId, linkRefNo) => {
		return this.init().get(
			`finsense/API/V2/FIDataReportPdf/${consentHandle}/${sessionId}/${linkRefNo}`,
			{
				responseType: 'blob', // need to change into blob for download use case
			}
		);
	};

	getFIDataReportXLSX = (consentHandle, sessionId, linkRefNo) => {
		return this.init().get(
			`finsense/API/V2/FIDataReportXlsx/${consentHandle}/${sessionId}/${linkRefNo}`,
			{
				responseType: 'blob',
			}
		);
	};

	getDashboardMetrics = () => {
		return this.init().get(`finsense-dashboard/metrics/fiu-metrics`);
	};

	getPFMMetrics = () => {
		return this.init().get(`/pfm/manage/dashboard/metrics`, {
			// baseURL: 'http://localhost:8080',
		});
	};

	getApprovedUserRoles = () => {
		return this.init().get(`finsense/API/V2/UserRole/Approved`);
	};

	getApprovedUsers = () => {
		return this.init().get(`finsense/API/V2/Users/Approved`);
	};

	getApprovedUserDetails = (userId) => {
		return this.init().get(`finsense/API/V2/Users/Approved/${userId}`);
	};

	getUsers = () => {
		return this.init().get(`finsense/API/V2/Users`);
	};

	getUserDetails = (userId) => {
		return this.init().get(`finsense/API/V2/Users/${userId}`);
	};

	getApprovedUserRoleDetails = (roleName) => {
		return this.init().get(`finsense/API/V2/UserRole/Approved/${roleName}`);
	};

	getUserRoles = () => {
		return this.init().get(`finsense/API/V2/UserRole`);
	};

	getUserRoleDetails = (roleName) => {
		return this.init().get(`finsense/API/V2/UserRole/${roleName}`);
	};

	getConsentTemplates = () => {
		return this.init().get(`finsense/API/V2/ConsentTemplates`);
	};

	// getConsentTemplates = () => {
	// 	return this.init().get(`finsense/API/V2/Templates`);
	// };

	getConsentTemplateDetails = (templateName) => {
		return this.init().get(`finsense/API/V2/ConsentTemplate/${templateName}`);
	};

	getApprovedConsentTemplateDetails = (templateName) => {
		return this.init().get(
			`finsense/API/V2/ConsentTemplate/Approved/${templateName}`
		);
	};

	getConfigObject = () => {
		return this.init().get(`finsense/API/V2/sdkconfig`);
	};

	getAccountsByConsentId = (consentId) => {
		return this.init().get(`finsense/API/V2/Consent/${consentId}`);
	};

	getSahamatiTemplateRules = (code) => {
		return this.init().get(`/finsense/API/V2/sahamatiTemplateRules/${code}`);
	};

	getSahamatiTemplateRulesCodes = () => {
		return this.init().get(`/finsense/API/V2/sahamatiTemplateRules/codes`);
	};
	

	deleteApprovedUser = (userId) => {
		return this.init().delete(`finsense/API/V2/Users/Approved/${userId}`);
	};

	deleteUser = (userId) => {
		return this.init().delete(`finsense/API/V2/Users/${userId}`);
	};

	deleteApprovedUserRole = (roleName) => {
		return this.init().delete(`finsense/API/V2/UserRole/Approved/${roleName}`);
	};

	deleteUserRole = (roleName) => {
		return this.init().delete(`finsense/API/V2/UserRole/${roleName}`);
	};

	deleteTemplate = (templateName) => {
		return this.init().delete(
			`finsense/API/V2/ConsentTemplate/${templateName}`
		);
	};

	deleteApprovedTemplate = (templateName) => {
		return this.init().delete(
			`finsense/API/V2/ConsentTemplate/Approved/${templateName}`
		);
	};

	postFiRequest =async (consentDetails) => {
		
		const accountResponse = await this.getAccountsByConsentId(consentDetails.requestConsentId);
		const consentArtefact = accountResponse?.data?.body?.ConsentDetail;

		const purposeCode = consentArtefact?.Purpose?.code;
		const fiTypes = consentArtefact?.fiTypes;

		const currentDate = new Date();
	 	const formattedDate = currentDate.toISOString();
	
		// Use consentDetails.dateTimeRangeTo as the end date
		const { fromTime, toTime } = getDateRangeByPurposeAndFiTypes(purposeCode, fiTypes, formattedDate);
		// Ensure fromTime is not before consentDetails.dateTimeRangeFrom
		const consentStart = new Date(consentDetails.dateTimeRangeFrom);
		const finalFromTime = new Date(fromTime) < consentStart ? consentDetails.dateTimeRangeFrom : fromTime;
	
		const body = {
			header: optionalHeaders,
			body: {
				custId: consentDetails.custId,
				consentId: consentDetails.requestConsentId,
				consentHandleId: consentDetails.consentHandle,
				dateTimeRangeFrom: finalFromTime,
				dateTimeRangeTo: toTime,
			},
		};
		return this.init().post(`finsense/API/V2/FIRequest`, body);
	};

	postConsentRequest = (consentDetails) => {
		const dataRangeStartMonthsNum =
			consentDetails.dataRange.unit === 'current'
				? 0
				: parseInt(consentDetails.dataRange.unit.split(' ')[1]);
		const body = {
			header: optionalHeaders,
			body: {
				custId: consentDetails.customerId,
				consentDescription: consentDetails.consentDesc,
				templateName: consentDetails.template,
				userSessionId: 'sessionid123',
				ConsentDetails: {
					Customer: { id: consentDetails.customerId },
					DataConsumer: { id: sessionStorage.getItem('fiuId') },
					Purpose: {
						...consentDetails.purpose,
						customPurposeText: consentDetails.customPurposeText,
					},
					consentMode: consentDetails.consentMode,
					consentTypes: consentDetails.consentType,
					fiTypes: consentDetails.fiType,
					fetchType: consentDetails.frequency,
					Frequency: {
						value: consentDetails?.frequencyPeriod.value,
						unit: consentDetails?.frequencyPeriod.unit,
					},
					DataFilter: getDataFilter(consentDetails?.dataFilter),
					DataLife: {
						value: consentDetails.dataLife.value,
						unit: consentDetails.dataLife.unit,
					},
					consentStart: getConsentStartDate(consentDetails.consentStart.value),
					consentExpiry: getConsentExpiryDate(
						consentDetails.consentStart.value,
						consentDetails.consentExpiry.value,
						consentDetails.consentExpiry.unit
					),
					FIDataRange: {
						from: dataRangeFrom(dataRangeStartMonthsNum),
						to: dataRangeTo(consentDetails.dataRange.value),
					},
				},
			},
		};
		return this.init().post(`/finsense/API/V2/ConsentRequestPlus`, body);
	};

	getGraphData = (inputData) => {
		return this.init().post(`/finsense-dashboard/metrics/graph`, inputData);
	};

	getPFMGraphData = (inputData) => {
		return this.init().post(`/pfm/manage/dashboard/graph`, inputData, {
			// baseURL: 'http://localhost:8080',
		});
	};

	createNewUser = (inputData) => {
		const body = {
			header: optionalHeaders,
			body: inputData,
		};
		return this.init().post(`finsense/API/V2/Users`, body);
	};

	postUserApproval = (userId) => {
		const body = {
			header: optionalHeaders,
			body: {
				userId,
			},
		};
		return this.init().post(`finsense/API/V2/Users/Approved`, body);
	};

	createNewUserRole = (inputData) => {
		const body = {
			header: optionalHeaders,
			body: inputData,
		};
		return this.init().post(`finsense/API/V2/UserRole`, body);
	};

	postUserRoleApproval = (roleName) => {
		const body = {
			header: optionalHeaders,
			body: {
				roleName,
			},
		};
		return this.init().post(`finsense/API/V2/UserRole/Approved`, body);
	};

	postConsentTemplate = (templateDetails) => {
		const dataRangeStartMonthsNum =
			templateDetails.dataRange.unit === 'current'
				? 0
				: parseInt(templateDetails.dataRange.unit.split(' ')[1]);
		const body = {
			header: optionalHeaders,
			body: {
				templateName: templateDetails.templateName,
				templateDescription: templateDetails.templateDescription,
				// userSessionId: 'sessionid123',
				consentMode: templateDetails.consentMode,
				// Customer: { id: templateDetails.customerId },
				consentTypes: templateDetails.consentType,
				fiTypes: templateDetails.fiType,
				Purpose: {
					...templateDetails.purpose,
					customPurposeText: templateDetails.customPurposeText,
				},
				fetchType: templateDetails.frequency,
				Frequency: {
					value: templateDetails?.frequencyPeriod.value,
					unit: templateDetails?.frequencyPeriod.unit,
				},
				DataFilter: getDataFilter(templateDetails?.dataFilter),
				DataLife: {
					value: templateDetails.dataLife.value,
					unit: templateDetails.dataLife.unit,
				},
				// DataConsumer: { id: sessionStorage.getItem('fiuId') },
				ConsentExpiry: {
					value: templateDetails.consentExpiry.value,
					unit: templateDetails.consentExpiry.unit,
				},
				// consentStartDays: templateDetails.consentStart,
				// dataRangeStartMonths: dataRangeStartMonthsNum,
				// dataRangeEndMonths: templateDetails.dataRange.value,
				consentStart: {
                    value: templateDetails.consentStart,
					unit: "DAY",
                },
                dataRangeStart: {
					value: dataRangeStartMonthsNum,
                    unit: "MONTH"
                },
                dataRangeEnd: {
					value: templateDetails.dataRange.value,
                    unit: templateDetails.dataRangeEndUnit
                },
				// FIDataRange: {
				// 	from: dataRangeFrom(dataRangeStartMonthsNum),
				// 	to: dataRangeTo(templateDetails.dataRange.value),
				// },
				sahamatiCode: templateDetails.sahamatiCode,
				businessPurpose : templateDetails.businessPurpose
			},
		};
		return this.init().post(`finsense/API/V2/ConsentTemplate`, body);
	};

	postTemplateApproval = (templateName) => {
		const body = {
			header: optionalHeaders,
			body: {
				templateName,
			},
		};
		return this.init().post(`finsense/API/V2/ConsentTemplate/Approved`, body);
	};

	editApprovedUserRole = (inputData) => {
		const body = {
			header: optionalHeaders,
			body: inputData,
		};
		return this.init().put(`finsense/API/V2/UserRole/Approved`, body);
	};

	editApprovedUser = (inputData) => {
		const body = {
			header: optionalHeaders,
			body: inputData,
		};
		return this.init().put(`finsense/API/V2/Users/Approved`, body);
	};

	editConsentTemplate = (templateDetails) => {
		const dataRangeStartMonthsNum =
			templateDetails.dataRange.unit === 'current'
				? 0
				: parseInt(templateDetails.dataRange.unit.split(' ')[1]);
		const body = {
			header: optionalHeaders,
			body: {
				templateName: templateDetails.templateName,
				templateDescription: templateDetails.templateDescription,
				// userSessionId: 'sessionid123',
				consentMode: templateDetails.consentMode,
				// Customer: { id: templateDetails.customerId },
				consentTypes: templateDetails.consentType,
				fiTypes: templateDetails.fiType,
				Purpose: {
					...templateDetails.purpose,
					customPurposeText: templateDetails.customPurposeText,
				},
				fetchType: templateDetails.frequency,
				Frequency: {
					value: templateDetails?.frequencyPeriod.value,
					unit: templateDetails?.frequencyPeriod.unit,
				},
				DataFilter: getDataFilter(templateDetails?.dataFilter),
				DataLife: {
					value: templateDetails.dataLife.value,
					unit: templateDetails.dataLife.unit,
				},
				// DataConsumer: { id: sessionStorage.getItem('fiuId') },
				ConsentExpiry: {
					value: templateDetails.consentExpiry.value,
					unit: templateDetails.consentExpiry.unit,
				},
				// consentStartDays: templateDetails.consentStart,
				// dataRangeStartMonths: dataRangeStartMonthsNum,
				// dataRangeEndMonths: templateDetails.dataRange.value,
				consentStart: {
                    value: templateDetails.consentStart,
					unit: "DAY",
                },
                dataRangeStart: {
					value: dataRangeStartMonthsNum,
                    unit: "MONTH"
                },
                dataRangeEnd: {
					value: templateDetails.dataRange.value,
                    unit: "MONTH"
                },
				// FIDataRange: {
				// 	from: dataRangeFrom(dataRangeStartMonthsNum),
				// 	to: dataRangeTo(templateDetails.dataRange.value),
				// },
				sahamatiCode: templateDetails.sahamatiCode,
				businessPurpose : templateDetails.businessPurpose
			},
		};
		return this.init().put(`finsense/API/V2/ConsentTemplate/Approved`, body);
	};

	editUserPassword = (inputData) => {
		const body = {
			header: optionalHeaders,
			body: inputData,
		};
		return this.init().put(`finsense/API/V2/User`, body);
	};
	getFipPerformanceScore = (range) => {
		const body = {
			header: optionalHeaders,
			body: {
				range: range,
				frequency: [],
				weightage: [],
			},
		};
		return this.init().post(`finsense/API/V2/fips/aggregate-metrics-all`, body);
	};
	getFipList = () => {
		return this.init().get(`finsense/API/V2/fips`);
	};

	getClassifiedTransactions = (transactions) => {
		const body = {
			transactions
		};
		return this.init().post(`finsense-dashboard/classify/transactions`, body);
	};
}
